<template>
  <div 
    class="drawer-item-wrapper"
    :class="expand ? 'expanded' : 'collapsed'"
  >
    <router-link
      :to="link"
    >
      <div 
        :class="(userpic ? 'pic-wrapper ' : 'product-wrapper ') + (fa ? 'fa-wrapper ' : ' ') + (active ? 'active' : 'inactive')"
      >
        <Userpic
          v-if="userpic"
        />
        
        <i 
          v-if="fa"
          :class="icon"
        />
        <img 
          v-else
          :src="iconUrl"
          :style="iconInlineStyle" 
          aria-hidden="true"
        >
      </div>
      <div 
        class="caption"
      >
        <span>
          {{ expand ? caption : name }}
        </span>
      </div>
    </router-link>
  </div>
</template>

<script>


import Userpic from "@/components/userpic/index.vue";
import { VTooltip } from 'v-tooltip'

export default {
  name: "DrawerItem",
  props: {
    icon: String,
    link: String,
    expand: Boolean,
    size: String,
    name: String,
    caption: String,
    userpic: Boolean,
    fa: Boolean,
    active: Boolean
  },
  directives: {
    VTooltip
  },
  components: {
    Userpic
  },
  computed: {


    iconUrl() {

      return !this.userpic ? require(`@/assets/product-icons/${this.icon}`) : '';

    }

  },
  data: function() {
    return {
      iconInlineStyle: {
        transform: "rotate(0deg)"
      },
      iconRotateDeg: 0
    };
  },

};

</script>

<style scoped lang="sass" >

.drawer-item-wrapper 
  display: flex
  flex-direction: row
  align-items: flex-start
  width: 100%
  height: auto
  padding-top: 3px
  padding-bottom: 3px
  padding-left: 5px
  padding-right: 5px
  opacity: 0.9
  


  a
    display: flex
    justify-content: center
    align-items: center
    width: 35px
    height: 35px

  .pic-wrapper
    width: 22px
    height: 22px

  .product-wrapper
    width: 35px
    height: 35px
    display: flex
    justify-content: center
    align-items: center
    overflow: hidden

    &.active
      border-bottom: 2px solid $color-text-success
      filter: brightness(1.1)

    &.fa-wrapper
      width: 22px
      height: 22px

    i
      font-size: 1.2em
      color: $color-text-main

  img
    width: 100%

  .caption
    margin-left: 0.6em
    align-items: center
    white-space: nowrap
    text-overflow: ellipsis
    overflow: hidden
    max-width: 140px

  &.expanded
    .caption
      display: flex

    a
      width: 100%
      justify-content: flex-start

  &.collapsed
    .caption
      display: none



</style>